import { render, staticRenderFns } from "./TankerTrucksForm.vue?vue&type=template&id=99e70632"
import script from "./TankerTrucksForm.vue?vue&type=script&lang=js"
export * from "./TankerTrucksForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports